// extracted by mini-css-extract-plugin
export default {"left":"eWM4D","center":"_1pCjR","right":"_2S9pY","onImage":"sHNqW","offImage":"NQv8M"};